import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateMapTypeAction } from 'actions/mapActions'
import { ROADMAP, SATELLITE, BLANK } from 'helpers/globals'
import mapView from 'assets/images/mapTypes/mapView.png'
import satelliteView from 'assets/images/mapTypes/satelliteView.jpg'

const mapStateToProps = ({ map: { mapType } }) => ({ mapType })

class MapTypeButtons extends React.Component {
  state = { isHovering: false }
  mapTypeListener = type => (_ => this.props.updateMapTypeAction(type))

  render() {
    const { props: { mapType, drawing, classes }, state: { isHovering }, mapTypeListener } = this

    const showSelectedMapType = _ => {
      if (mapType === ROADMAP) return <img src={mapView} />
      else if (mapType === SATELLITE) return <img src={satelliteView} />

      return <div className={classes.blankView} />
    }

    return (
      <div
        className={classes.container + (drawing ? ` ${classes.blockClick}` : '')}
        onMouseLeave={_ => this.setState({ isHovering: false })}
      >
        <div
          className={classes.mapTypeButton}
          onMouseEnter={_ => !drawing && this.setState({ isHovering: true })}
        >
          {showSelectedMapType()}
          Map Types
        </div>
        <div
          className={classes.mapTypesContainer} style ={{ display: isHovering ? 'flex' : 'none' }}>

          { mapType !== SATELLITE && <div onClick={mapTypeListener(SATELLITE)} className={classes.mapButton}><img src={satelliteView} />Satellite</div> }

          { mapType !== ROADMAP && <div onClick={mapTypeListener(ROADMAP)} className={classes.mapButton}><img src= {mapView} />Map</div> }

          { mapType !== BLANK && <div onClick={mapTypeListener(BLANK)} className={classes.mapButton}><div className={classes.blankView} />Blank</div> }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateMapTypeAction })(injectSheet(style)(MapTypeButtons))



// WEBPACK FOOTER //
// ./src/components/MapComponents/MapTypeButtons/index.js